// Глобальная модалка входа. Открывается из любой точки («Войти» в topbar/
// sidebar/drawer/лендинг) и при попытке гостя зайти в закрытый раздел —
// вместо перехода на отдельную страницу /auth/login с лишним кликом.
// Монтируется один раз в __root.tsx (<LoginModal />), как upgrade-modal/
// session-expiry. См. rules/frontend-state.md §5.4.
import { create } from "zustand";

interface LoginModalState {
	isOpen: boolean;
	/** Куда вернуться после успешного входа (по умолчанию текущий путь). */
	returnTo?: string;
	/**
	 * Код ошибки SSO-возврата (`sso_failed`, `google_failed`, …). Раньше его
	 * показывала только страница `/auth/login`; после того как страница стала
	 * редиректом на главную, единственная поверхность входа — эта модалка, и без
	 * поля пользователь молча возвращался бы на главную без объяснения отказа.
	 */
	errorCode?: string;
	open: (returnTo?: string, errorCode?: string) => void;
	close: () => void;
}

export const useLoginModalStore = create<LoginModalState>((set) => ({
	isOpen: false,
	returnTo: undefined,
	errorCode: undefined,
	open: (returnTo, errorCode) => set({ isOpen: true, returnTo, errorCode }),
	close: () => set({ isOpen: false, returnTo: undefined, errorCode: undefined }),
}));
